import { render, staticRenderFns } from "./FingerSvg.vue?vue&type=template&id=56491a4a"
import script from "./FingerSvg.vue?vue&type=script&lang=js"
export * from "./FingerSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports